<div class="switch-graph-mode-container" (window:resize)="onResize()">
  <div class="graph-mode-switch-container">
    <div class="moving-part" id="moving-part-mode"></div>
    <div
      class="single-option global-transition"
      *ngFor="let mode of switchButtons; index as i"
      (click)="switchMode(mode)"
      id="{{ mode.id }}"
      [ngClass]="{ 'active-mode' : mode.id === activeMode?.id, 'left' : i === 0, 'right' : i === 1 }">
      <h3>{{ section === 'ppi' ? ( mode.name | translate ) : (('view_translations.' + mode.name) | translate) }}</h3>
    </div>
  </div>
</div>
